import { render } from "./GraphQL-ConnectedDemo.vue?vue&type=template&id=51656c5c"
import script from "./GraphQL-ConnectedDemo.vue?vue&type=script&lang=js"
export * from "./GraphQL-ConnectedDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__